import { z } from "zod";

export const emailSignInSchema = z.object({
	email: z.string().email(),
	password: z.string().min(2).max(50),
	keepMeSignedIn: z.boolean(),
	twoFactorToken: z.string().optional(),
});

export type EmailSignInSchema = z.infer<typeof emailSignInSchema>;
